<template>
  <div class="exams-list">
    <v-container>
      <exam-result model="shrinked"/>
    </v-container>
    <page-top v-bind="pageTop">
      <search-input placeholder="Busque por exames"
        :loading="isLoading"
        @clear="onSearch('')"
        @search="onSearch($event)" />
    </page-top>
    <v-container>
      <v-mockup v-if="isLoading && !exams.length" tag="ul" :counter="8" widget="exam" />
      <div class="exams-list__empty" v-else-if="!isLoading && itemsNotFound">
        <v-heading level="h6">Sem resultados <b v-if="search">para "{{search}}"</b></v-heading>
        <p>Confira se não há erros de digitação e tente novamente.</p>
      </div>
      <ul v-else>
        <li v-for="(exam, index) in exams" :key="index">
          <v-exam v-bind="exam" />
        </li>
      </ul>
      <v-btn model="color-a"
        :small="true"
        :outline="true"
        :status="status"
        @click="paginateItems()"
        v-if="!isLastPage && !itemsNotFound"
        class="load">
          Carregar mais exames
      </v-btn>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import ExamResult from '@/components/exams/ExamResult.vue';
import PageTop from '@/components/layout/PageTop.vue';
import Container from '@/components/layout/Container.vue';
import Heading from '@/components/uikit/text/Heading.vue';
import Exam from '@/components/exams/Exam.vue';
import Mockup from '@/components/uikit/mockup/Mockup.vue';
import Btn from '@/components/uikit/Btn.vue';
import SearchInput from '@/components/widgets/SearchInput.vue';

const meta = [
  {
    vmid: 'description',
    name: 'description',
    content: 'Conheça todos os exames realizados pela URC, proporcionando aos seus clientes a realização de exames diagnósticos por imagem com o maior conforto possível e resultados precisos. Por isso acreditamos num atendimento humanizado e investe constantemente na renovação de seus aparelhos para diagnósticos cada vez mais precisos.',
  },
  {
    vmid: 'og:description',
    name: 'og:description',
    content: 'Conheça todos os exames realizados pela URC, proporcionando aos seus clientes a realização de exames diagnósticos por imagem com o maior conforto possível e resultados precisos. Por isso acreditamos num atendimento humanizado e investe constantemente na renovação de seus aparelhos para diagnósticos cada vez mais precisos.',
  },
];

export default {
  name: 'ExamsList',
  components: {
    'exam-result': ExamResult,
    'page-top': PageTop,
    'v-container': Container,
    'v-heading': Heading,
    'v-exam': Exam,
    'v-mockup': Mockup,
    'v-btn': Btn,
    'search-input': SearchInput,
  },
  metaInfo: {
    title: 'Exames',
    meta,
  },
  computed: {
    ...mapState({
      exams: state => state.exams.list.items,
      status: state => state.exams.list.status,
      search: state => state.exams.list.filters.search || '',
      pageTop: state => state.exams.page.content,
    }),
    ...mapGetters({
      isLoading: 'exams/list/isLoading',
      isLastPage: 'exams/list/isLastPage',
      itemsNotFound: 'exams/list/itemsNotFound',
    }),
  },
  async created() {
    this.$store.dispatch('exams/list/reset');
    await this.$store.dispatch('exams/page/getContent');
    await this.$store.dispatch('exams/list/paginateItems');
  },
  methods: {
    async onSearch(search) {
      this.$store.dispatch('exams/list/reset');
      this.$store.commit('exams/list/setFilters', { search });
      await this.$store.dispatch('exams/list/paginateItems');
    },
    async paginateItems() {
      await this.$store.dispatch('exams/list/paginateItems');
    },
  },
};
</script>

<style lang="scss" scoped>
$component: '.exams-list';
#{$component} {
  padding: $section-gutter 0 $section-gutter;
  background-color: $bg-gray;
  .exam-result,
  .page-top {
    margin-bottom: $gutter-xxl;
  }
  .page-top {
    /deep/ h2:nth-child(2) {
      color: $color-a;
    }
    .exam-result /deep/ .exam-result-form {
      max-width: 400px;
    }
  }
  ul {
    display: grid;
    grid-template-rows: auto;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 0 $gutter-l;
    margin-bottom: $section-gutter;
    text-align: center;
    @media screen and (max-width: $brakepoint-large) {
      grid-template-columns: repeat(2, 1fr);
    }
    @media screen and (max-width: $brakepoint-small) {
      display: block;
    }
    > li {
      margin-bottom: $gutter-l;
    }
  }
  &__empty {
    text-align: center;
    p {
      font-size: $font-size-l;
      color: $color-sys-e;
    }
  }
  .load {
    display: block;
    width: 200px;
    margin: auto;
  }
}
</style>
